import script from "./CustomCarousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomCarousel.vue?vue&type=script&lang=ts&setup=true"

import "./CustomCarousel.vue?vue&type=style&index=0&id=6b9b6a8d&lang=scss"

const __exports__ = script;

export default __exports__